import React, { Component } from 'react';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import { TriangleOpen } from '../../../common/icons';
import styles from './style.scss';

export default class MenuDropdownButton extends Component {

    render() {
        
        const { selectedItemText, onClick } = this.props;

        return (
            <RaisedButton
                onClick={onClick}
                className={classNames(styles.menuDropdownButton)}
            >
                <div
                    className={classNames(styles.menuDropdownButtonText)}
                >
                    <span>
                        {selectedItemText}{' '}
                    </span>
                    <TriangleOpen />
                </div>
            </RaisedButton>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/controls/menuDropdown/menuDropdownButton.jsx